import React, { useState } from 'react'
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  ScrollView
} from 'react-native'
import { usepaycheckStore } from '../../../stores/paycheck'
import { colorPalette, globalStyles } from '../../../static/styles/global'
import {
  Ionicons,
  AntDesign,
  Feather
} from '@expo/vector-icons'
import CardSeparator from '../../../components/shared/card/CardSeparator'
import { useNavigation } from '@react-navigation/native'
import ModalPopup from '../../../components/shared/modal/ModalPopup'
import CustomButton from '../../../components/shared/button/Button'
import { useInitializeStore } from '../../../stores/initialize'

const Deposithelper = ({ fkey, obkey, mode }: any) => {
  const paycheckstore = usepaycheckStore()
  const navigation = useNavigation<any>()

  const [visible, setVisible] = useState(false)
  const initializestore = useInitializeStore()

  const handledelete = async (depositKey: any) => {
    const data: any = await paycheckstore.deleteDepositDetails(depositKey)
    if (data?.success) {
      setVisible(!visible)
      paycheckstore.getDepositDetails(initializestore.initializeData.userkey)
    }
  }
  return (
    <ScrollView>
      {paycheckstore.depositData?.data?.map((item, index) => {
        return (
          <View key={index} style={[styles.CardProfile, { marginVertical: 5 }]}>
            <View >
              {/* Row 1 */}
              <View style={styles.row}>
                <View style={styles.left}>
                  <Text style={styles.titleHead}>Routing Number</Text>
                  <Text style={styles.titleValue}>{item.routingNumber}</Text>
                </View>
                <View style={styles.center}>
                  <Text style={styles.titleHead}>Account Number</Text>
                  <Text style={styles.titleValue}>{item.accountNumber}</Text>
                </View>
                <View style={styles.right}>
                  <Text style={styles.titleHead}>Amount</Text>
                  <Text style={styles.titleValue}>
                    {/* {item.amount != null
                      ? `$${new Intl.NumberFormat('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(item.amount)}`
                      : 'Net'} */}
                    {index == 0 ? 'Net' : `$${new Intl.NumberFormat('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(item.amount)}`}
                  </Text>
                </View>
              </View>

              <CardSeparator />

              {/* Row 2 */}
              <View style={styles.row}>
                <View style={styles.left}>
                  <Text style={styles.titleHead}>Account Type</Text>
                  <Text style={styles.titleValue}>{item.accountType}</Text>
                </View>
                <View style={styles.center}>
                  <Text style={styles.titleHead}>Financial Institution</Text>
                  <Text style={styles.titleValue}>{item.financialInstitution}</Text>
                </View>

                <View style={styles.right}>
                  <View style={styles.actions}>
                    <TouchableOpacity onPress={() => paycheckstore.downloadFile(item.filePath)}>
                      <AntDesign name="download" size={20} color={colorPalette.tertiary} />
                    </TouchableOpacity>
                    <TouchableOpacity
                      style={{ marginHorizontal: 8 }}
                      onPress={() =>
                        navigation.navigate('Editdirectdeposit', { item, index, fkey, obkey, mode })
                      }>
                      <Feather name="edit" size={20} color={colorPalette.tertiary} />
                    </TouchableOpacity>
                    {index > 0 && (
                      <TouchableOpacity onPress={() => setVisible(!visible)}>
                        <Feather name="trash-2" size={20} color={colorPalette.red} />
                      </TouchableOpacity>
                    )}
                  </View>
                </View>
              </View>
            </View>

            <ModalPopup
              visible={visible}
              position="middle"
              screen="dropdown"
              flatBottom={false}
            >
              <View style={styles.modalHeader}>
                <Text
                  style={[
                    globalStyles.text,
                    globalStyles.fs18,
                    globalStyles.fwBold,
                    globalStyles.blackTextColor
                  ]}
                >
                  Confirm Delete
                </Text>
                <TouchableOpacity onPress={() => setVisible(!visible)}>
                  <Ionicons
                    name="close-sharp"
                    size={24}
                    color={colorPalette.black}
                  />
                </TouchableOpacity>
              </View>
              <View style={{ padding: 10 }}>
                <Text
                  style={{
                    textAlign: 'center',
                    padding: 5,
                    fontWeight: '600',
                    fontSize: 16
                  }}
                >
                  Are you sure you want to delete this item?
                </Text>
                <View
                  style={{
                    flexDirection: 'row',
                    justifyContent: 'center',
                    margin: 5
                  }}
                >
                  <View style={{ margin: 5 }}>
                    <CustomButton
                      text={'Cancel'}
                      onPress={() => setVisible(!visible)}
                      color="danger"
                    />
                  </View>
                  <View style={{ margin: 5 }}>
                    <CustomButton
                      text={'Ok'}
                      onPress={() => {
                        handledelete(item.depositKey)
                      }}
                      color="success"
                    />
                  </View>
                </View>
              </View>
            </ModalPopup>
          </View>
        )
      })}
    </ScrollView>
  )
}
const styles = StyleSheet.create({
  CardProfile: {
    backgroundColor: colorPalette.light,
    padding: 10,
    borderRadius: 8
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',

  },


  left: {
    flex: 1,
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  center: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  right: {
    flex: 1,
    alignItems: 'flex-end',
    justifyContent: 'center',
  },


  titleHead: {
    fontSize: 12,
    fontWeight: '600',
    color: '#0B495C',
    marginBottom: 2,
  },
  titleValue: {
    fontSize: 12,
    color: '#444',
  },


  actions: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  modalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    paddingHorizontal: 16,
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderColor: colorPalette.darkLight
  },
})
export default Deposithelper
